export const IS_LOCAL_DEV = process.env.NODE_ENV === 'development';
export const BUILD_ID = process.env.REACT_APP_BUILD_ID || '';
export const IS_EDITOR_MODE = /\/form\/\w+\/\d+\/edit$/i.test(window.location.pathname);
export const APP_RUNNING_ENV = process.env.REACT_APP_RUNNING_ENV || 'prod';

export const RECAPTCHA_SITE_KEY =
    process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdbD7kUAAAAAHBmg7tQxM1KyJ20kRhl-cDjWlIW';
export const FROALA_KEY =
    process.env.REACT_APP_FROALA_V2_KEY_GENERAL || 'ZF3G4I3A7aD6C4C3F2G3D2J2C9C3D5tooB-8iJ-7A-21d1sxsC-9B1vyz==';
export const EDITOR_WINDOW_ORIGIN = process.env.REACT_APP_FEVER_HOST
    ? `https://${process.env.REACT_APP_FEVER_HOST}`
    : window.location.origin;
export const NEW_FEVER_HOST =
    process.env.REACT_APP_FEVER_HOST || filterFeverWWWDomain(window.location.host);
export const INTERCOM_SECRET_KEY =
    process.env.REACT_APP_INTERCOM_SECRET_KEY || 'xdsqVb3gLQtypbClG8EZFFSh4Mx_PRTcHLTQT073';

export const { FEVER_API_ENDPOINT } = (runningEnv => {
    switch (runningEnv) {
        case 'prod':
            return {
                FEVER_API_ENDPOINT: 'https://api.feversocial.com'
            };
        case 'dev':
        default:
            return {
                FEVER_API_ENDPOINT: 'https://api.dev.feversocial.com'
            };
    }
})(APP_RUNNING_ENV);

function filterFeverWWWDomain(host) {
    return host === 'www.feversocial.com' ? 'feversocial.com' : host;
}
